import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/pitstop_config'
const plural = 'pitstopconfig'
const single = 'pitstopconfig'

const pitstopConfig = new ApiCore({
	index: true,
	findOne: false,
	findAll: false,
	create: false,
	update: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

pitstopConfig.getApiKey = (_parameter, _key) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/api_key`)
		.then(handleResponse)
		.catch(handleError);
}

pitstopConfig.getJwtKey = (_parameter, _key) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/jwt_sym`)
		.then(handleResponse)
		.catch(handleError);
}


export default pitstopConfig
